"use client";
import BlokWrap from "@/components/bloks/BlokWrap";

import { SegmentControl } from "@/components/SegmentControl";
import { useGlobal } from "@/features/global/GlobalContext";
import { Link } from "@/i18n/Link";
import { trackContentClick } from "@/lib/analytics/trackContentClick";
import { sbLink } from "@/lib/storyblok/link";
import type { BlokLink } from "@/storyblok";
import type { BlokProps } from "@frend-digital/storyblok";
import type { StoryblokMultilink } from "storyblok";
import styles from "./Link.module.css";

export const LinkBlok = ({ blok }: BlokProps<BlokLink>) => {
	const {
		data: { colorMap },
	} = useGlobal();
	const link = sbLink(blok.link as StoryblokMultilink);
	const colorEntry = colorMap[blok.color!] || "";
	return (
		<SegmentControl segments={blok}>
			<BlokWrap editable={blok}>
				{link?.href && (
					<Link
						href={link?.href!}
						style={{ color: colorEntry.color }}
						className={styles.root}
						onClick={() =>
							trackContentClick({
								contentType: blok.component,
								itemId: blok._uid,
								href: link.href,
								label: blok.text,
							})
						}
					>
						{blok.text}
					</Link>
				)}
			</BlokWrap>
		</SegmentControl>
	);
};
